import * as _ from 'lodash';
import { Destroyable } from '../../../common';
import { IDataSourceConfig } from '../../../interface/file';
import { DataSourceConfig } from './data.source.config';

export class DataSourceConfigSet extends Destroyable {

  private _parent: DataSourceConfigSet;
  private _array: Array<DataSourceConfig> = [];

  constructor(dataSourceConfigArray?: IDataSourceConfig | Array<IDataSourceConfig>) {
    super();
    this.load(dataSourceConfigArray);
    this.onDestroy(() => {
      this._array.splice(0);
      this._array = null;

      this._parent = null;
    });
  }

  /**
   * 设置当前set的上游set，当前set中的dataSourceConfig覆盖上游set中的同名dataSourceConfig
   * @param value
   */
  set parent(value: DataSourceConfigSet) {
    this._parent = value;
  }

  /**
   *
   */
  get values(): Array<DataSourceConfig> {
    return !!this._parent ? this._parent.values.concat(this._array) : this._array.slice(0);
  }

  has(id: string): boolean {
    return (this._array.findIndex((dataSourceConfig: DataSourceConfig) => {
      return dataSourceConfig.id === id;
    }) >= 0) || (this._parent ? this._parent.has(id) : false);
  }

  getDataSourceConfig(id: string): DataSourceConfig {
    return this._array.find((value) => {
      return value.id === id;
    }) || (this._parent ? this._parent.getDataSourceConfig(id) : null);
  }

  load(array: IDataSourceConfig | Array<IDataSourceConfig>) {
    if (_.isArray(array)) {
      array.forEach((value) => {
        this._load(value);
      });
    } else if (_.isObjectLike(array)) {
      this._load(array as IDataSourceConfig);
    }
  }

  private _load(dataSourceConfig: IDataSourceConfig) {
    this._array.push(new DataSourceConfig(dataSourceConfig));
  }
}
